import { useParams, useLocation } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { LEGAL_PAGES } from "@/data/site";
import { useLocale } from "@/context/LocaleContext";

const Legal = () => {
  const { locale, t } = useLocale();
  const params = useParams();
  const { pathname } = useLocation();
  const legalKey = params.legalKey || pathname.replace("/", "");
  const page = LEGAL_PAGES[legalKey];

  useSeo({ title: page ? `${t(page.titre)} — Entre les Mondes` : null, description: page ? `${t(page.titre)} ${locale === "en" ? "for Entre Les Mondes, Ludovic Isoz, Orbe, Switzerland." : "du site Entre Les Mondes, Ludovic Isoz, Orbe (Suisse)."}` : "" });

  if (!page) return null;

  return (
    <div className="pt-40 pb-24">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <p className="eyebrow mb-4">{locale === "en" ? "Legal information" : "Informations légales"}</p>
          <h1 className="font-serif text-4xl lg:text-5xl text-bark mb-14" data-testid="legal-title">{t(page.titre)}</h1>
        </Reveal>
        <div className="space-y-12">
          {page.sections.map((s, i) => (
            <Reveal key={s.titre} delay={i * 0.05}>
              <section data-testid={`legal-section-${i}`}>
                <h2 className="font-serif text-2xl text-bark mb-3">{s.titre}</h2>
                <p className="text-fumee leading-relaxed text-sm">{s.texte}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Legal;
